(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5401],{

/***/ 65886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Softwares; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/software/FeatSoftwares.tsx


var _excluded = ["isMobile", "allSoftwares"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var dataSource = function dataSource(allSoftwares) {
  return {
    wrapper: {
      className: 'home-page-wrapper content0-wrapper'
    },
    page: {
      className: 'home-page content0'
    },
    OverPack: {
      playScale: 0.3
    },
    titleWrapper: {
      className: 'feature7-title-wrapper',
      children: [{
        name: 'title',
        className: 'feature7-title-h1',
        children: 'Popular Stock software'
      }]
    },
    blockWrapper: {
      className: 'feature7-block-wrapper',
      gutter: 24,
      children: allSoftwares.map(function (software, idx) {
        var _software$attributes = software.attributes,
            slug = _software$attributes.slug,
            name = _software$attributes.name,
            details = _software$attributes.details;
        return {
          md: 6,
          xs: 24,
          name: "block".concat(idx),
          className: 'feature7-block',
          children: {
            className: 'feature7-block-group',
            href: '/software/[slug]',
            as: "/software/".concat(slug),
            children: [{
              name: 'image',
              className: 'feature7-block-image',
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                alt: "CalIcon",
                src: "https://gw.alipayobjects.com/zos/rmsportal/ruHbkzzMKShUpDYMEmHM.svg",
                width: "16",
                height: "16"
              })
            }, {
              name: 'title',
              className: 'feature7-block-title',
              children: name
            }, {
              name: 'content',
              className: 'feature7-block-content',
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((react_markdown_default()), {
                children: details.split(' ', 10).join(' ')
              })
            }]
          }
        };
      })
    }
  };
};

function FeatSoftware(props) {
  var isMobile = props.isMobile,
      allSoftwares = props.allSoftwares,
      tagProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var CalculatorDatasource = dataSource(allSoftwares);
  var blockWrapper = CalculatorDatasource.blockWrapper,
      titleWrapper = CalculatorDatasource.titleWrapper;

  if (blockWrapper.children.length === 0) {
    return null;
  }

  var childrenToRender = blockWrapper.children.map(function (item, i) {
    return /*#__PURE__*/(0,react.createElement)(col/* default */.Z, _objectSpread(_objectSpread({}, item), {}, {
      key: i.toString()
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: item.children.href,
      as: item.children.as,
      className: item.children.className,
      children: item.children.children.map(util/* getChildrenToRender */.TU)
    }));
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, tagProps), CalculatorDatasource.wrapper), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", _objectSpread(_objectSpread({}, CalculatorDatasource.page), {}, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, CalculatorDatasource.titleWrapper), {}, {
        children: titleWrapper.children.map(util/* getChildrenToRender */.TU)
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        gutter: [24, 24],
        children: childrenToRender
      })]
    }))
  }));
}

/* harmony default export */ var FeatSoftwares = (FeatSoftware);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
;// CONCATENATED MODULE: ./pages/trading-softwares.tsx






var title = "Trading Software, Apps & Tools";
var description = "A list of popular stock trading software,applications, tools and products. \n             Know features, key highlights, advantages, disadvantages, FAQs on investing apps.";
var __N_SSG = true;
function Softwares(props) {
  var pageData = props.data;
  var allBrokers = pageData.all_brokers.data,
      navCalculators = pageData.nav_calculators.data,
      allSoftwares = pageData.all_softwares.data,
      allPages = pageData.all_pages.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatSoftwares, {
      allSoftwares: allSoftwares
    }, "FeatSoftware")]
  });
}

/***/ }),

/***/ 91967:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trading-softwares",
      function () {
        return __webpack_require__(65886);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,2682,8182,9774,2888,179], function() { return __webpack_exec__(91967); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);